<template>
    <div class="form-element form-group">
        <slot name="label" :label="label" :id="id">
            <label v-if="label" :for="id" v-c:optional="isOptional">
                {{ label }}
                <hint v-if="hint">
                    <div v-html="hint"></div>
                </hint>
            </label>
        </slot>

        <slot name="description" :description="description">
            <div v-if="description" class="description">{{ description }}</div>
        </slot>

        <slot name="message" v-if="$v && $v.$anyError && errors.length > 0">
            <div class="alert alert-danger">
                <p v-for="error in errors" :key="error">
                    <slot :name="'message_'+error" :params="$v.$params[error]">
                        {{ getErrorMessage(error, $v.$params[error]) }}
                    </slot>
                </p>
            </div>
        </slot>

        <slot :id="id">
            <template v-if="component">
                <component :is="component" v-model="localValue" v-bind="props"/>
            </template>
            <template v-else>
                <input type="text"
                       v-model="localValue"
                       :id="id"
                       class="form-control"
                       v-c:has-error="$v && $v.$anyError"
                       ref="input"
                />
            </template>
        </slot>
    </div>
</template>

<script>
    import get from 'lodash/get';
    import set from 'lodash/set';

    export default {
        props: {
            name: {type: String, default: null},
            value: {default: null},
            label: {type: String, default: null},
            description: {type: String, default: null},
            component: {type: String, default: null},
            props: {type: Object, default: () => ({})},
            hint: {type: String, default: null},
            focus: {type: Boolean, default: false},
            optional: {type: Boolean, default: null},
        },

        computed: {
            formParent() {
                if (this.name !== null) {
                    let parent = this.$parent;
                    while (parent) {
                        if (parent.$form instanceof Object) {
                            return parent;
                        }
                        parent = parent.$parent;
                    }
                }
                return null;
            },

            localValue: {
                get() {
                    if (this.name !== null) {
                        return get(this.formParent.$form, this.name, null);
                    }
                    return this.value;
                },
                set(value)  {
                    if (this.name !== null) {
                        set(this.formParent.$form, this.name, value);
                    } else {
                        this.$emit('input', value);
                    }
                },
            },

            $v() {
                return this.name === null ? null : get(this.formParent.$v, this.name, null);
            },

            isOptional() {
                if (this.optional !== null) {
                    return this.optional;
                }
                if (this.name === null && this.$v === null) {
                    return false;
                }
                return !this.$v || !this.$v.hasOwnProperty('required');
            },

            id() {
                return 'el_' + this._uid;
            },

            errors() {
                if (!this.$v) {
                    return [];
                }
                return Object.keys(this.$v).filter(key => key[0] !== '$' && this.$v[key] === false);
            },
        },

        methods: {
            getErrorMessage(error, params) {
                console.debug('validation failed: ' + error, params);
                let message = this.__(`validation/${error}`, params);
                if (!message) {
                    message = this.__('validation/default');
                }
                return message;
            },
        },

        mounted() {
            if (this.focus && this.$refs.input) {
                this.$refs.input.focus();
            }
        },
    };
</script>
